<template>
<div class="warrp1200 css-footer">
    <div class="page-link">
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/index"
        
        >About YorkBBS</a
      >
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/aboutus"
        
        >关于我们</a
      >
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/ads"
        
        >广告服务</a
      >
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/concat"
        
        >联系方式</a
      >
      <a href="mailto:marketing@yorkbbs.ca" 
        >媒体合作</a
      >
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/policy"
        
        >免责声明</a
      >
      <a target="_blank" href="//corp.yorkbbs.ca/maps">网站导航</a>
    </div>
    <div class="copyright-info" >
        <div class="blk-cont">
            <div>广告热线：416-628-9108</div>
            <div>
                广告邮件：<a href="mailto:info@yorkbbs.ca" >info@yorkbbs.ca</a>
            </div>
      </div>
      <div class="coryright-time">
        Copyright © 2002-{{ newYear }} <span>Yorkbbs.ca 约克论坛 版权所有</span>
      </div>
    </div>
</div>
</template>
<script>
export default {
    name:'CssFooter',
    data(){
        return {

        }
    },
    computed:{
        newYear(){
            return new Date().getFullYear()
        }
    }
}
</script>
<style scoped>
.css-footer{overflow: hidden; font-size: 12px; padding-top: 10px;}
.css-footer a:hover{color: #e43a3a;}
.css-footer .page-link{display: none;}
.css-footer .copyright-info{display: flex; flex-direction: column; justify-content: center; align-items: center;}
.css-footer .copyright-info>div{display: flex; margin-bottom: 10px;}
.css-footer .copyright-info .blk-cont >div{margin:0 5px}
.css-footer .copyright-info .coryright-time>span{margin-left: 5px;}
@media screen and (min-width:768px) {
    .css-footer{padding: 20px 0 10px;}
    .css-footer .page-link{display: flex; justify-content: center; margin-bottom: 10px;}
    .css-footer .page-link a{padding:0 10px; position: relative; line-height: 18px;}
    .css-footer .page-link a:after{position: absolute; content:''; right: 0; top: 1px; width: 1px; height: 16px; background: #ccc;}
    .css-footer .page-link a:last-child:after{display: none;}
    .css-footer .copyright-info{flex-direction: row;}
    .css-footer .copyright-info>div{margin:0 10px}
}
</style>